import { render, staticRenderFns } from "./ownerDiningList.vue?vue&type=template&id=fea327ea&scoped=true"
import script from "./ownerDiningList.vue?vue&type=script&lang=js"
export * from "./ownerDiningList.vue?vue&type=script&lang=js"
import style0 from "./ownerDiningList.vue?vue&type=style&index=0&id=fea327ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea327ea",
  null
  
)

export default component.exports